const GOOGLE_ADDRESS_VALIDATION_API = "https://addressvalidation.googleapis.com/v1:validateAddress"

const getCountryCode = (countryName) => {
  const countryMap = {
    "United States": "US",
    "USA": "US",
    "United Kingdom": "GB",
    "UK": "GB",
    "Canada": "CA",
    "Australia": "AU",
    "India": "IN",
    "Germany": "DE",
    "France": "FR",
    "Japan": "JP",
    "China": "CN",
    "Brazil": "BR",
    "Mexico": "MX",
    "Spain": "ES",
    "Italy": "IT",
    "Netherlands": "NL",
    "Sweden": "SE",
    "Norway": "NO",
    "Denmark": "DK",
    "Finland": "FI",
    "Poland": "PL",
    "Ukraine": "UA"
  }
  
  return countryMap[countryName] || "US"
}

export const validateAddress = async (addressComponents, apiKey) => {
  try {
    const { street_address, city, state, zip_code, country } = addressComponents

    const addressLines = []
    if (street_address) addressLines.push(street_address)
    
    const cityStateZip = [city, state, zip_code].filter(Boolean).join(", ")
    if (cityStateZip) addressLines.push(cityStateZip)
    
    if (country) addressLines.push(country)

    const requestBody = {
      address: {
        regionCode: getCountryCode(country),
        addressLines: addressLines
      },
      enableUspsCass: false
    }

    const response = await fetch(`${GOOGLE_ADDRESS_VALIDATION_API}?key=${apiKey}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    })

    if (!response.ok) {
      throw new Error(`Address Validation API error: ${response.status}`)
    }

    const data = await response.json()
    
    return {
      success: true,
      verdict: data.result?.verdict,
      address: data.result?.address,
      geocode: data.result?.geocode,
      uspsData: data.result?.uspsData,
      formattedAddress: data.result?.address?.formattedAddress,
      postalAddress: data.result?.address?.postalAddress
    }
  } catch (error) {
    console.error("Address validation error:", error)
    return {
      success: false,
      error: error.message
    }
  }
}

export const extractFieldSuggestions = (validationResult) => {
  if (!validationResult.success) {
    return null
  }

  const postal = validationResult.postalAddress
  
  let streetAddress = postal?.addressLines?.[0] || ""
  
  if (!streetAddress && validationResult.formattedAddress) {
    streetAddress = validationResult.formattedAddress
  }
  
  const suggestions = {
    street_address: streetAddress,
    city: postal?.locality || "",
    state: postal?.administrativeArea || "",
    zip_code: postal?.postalCode || "",
    country: postal?.regionCode || ""
  }
  
  console.log("Extracted field suggestions:", suggestions)
  
  return suggestions
}

export const isAddressValid = (validationResult) => {
  if (!validationResult.success || !validationResult.verdict) {
    return false
  }

  const verdict = validationResult.verdict
  
  return (
    validationResult.geocode?.location &&
    verdict.validationGranularity !== "OTHER"
  )
}
